// Define your per-environment BASE URLs as constants:
const DEV_BASE = 'https://dev.thetwinmaster.com';
const ARCHE_BASE = 'https://arche.thetwinmaster.com';
const LOCAL_BASE = 'http://localhost:5050';

const DEV_COOKIE = "dev-twinup";
const ARCHE_COOKIE = "arche-twinup";
const LOCAL_COOKIE = "local-twinup";

// const DEV_CLOUDFRONT = "https://dpqyuz75hai1t.cloudfront.net";
// const ARCHE_CLOUDFRONT = "https://d34acseoi0567n.cloudfront.net";
// const LOCAL_CLOUDFRONT = "http://localhost:5050";

const DEV_CLOUDFRONT = "https://dxuq3hz574omv.cloudfront.net";
const ARCHE_CLOUDFRONT = "https://d1alkbkxc8st8w.cloudfront.net";
const LOCAL_CLOUDFRONT = "http://localhost:5050";

const DEV_CLOUDFRONT_S3 = "https://d2432f8n8m2znv.cloudfront.net";
const ARCHE_CLOUDFRONT_S3 = "https://d33ro0xhr21k4y.cloudfront.net";
const LOCAL_CLOUDFRONT_S3 = "http://localhost:5050";

// Helper to normalize matching
function getEnvType() {
    const { hostname, origin } = window.location;
    // console.log(`hostname: ${hostname}, origin: ${origin}`);
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        // Allow targeting a remote backend while developing locally,
        // e.g. REACT_APP_LOCAL_TARGET=dev in .env
        return process.env.REACT_APP_LOCAL_TARGET || 'local';
    }
    if (origin === DEV_BASE) {
        return 'dev';
    }
    if (origin === ARCHE_BASE) {
        return 'arche';
    }
    return 'arche';
}

export function getBaseUrl() {
    const env = getEnvType();
    if (env === 'local') return LOCAL_BASE;
    if (env === 'dev') {
        // When running locally targeting dev backend, use relative URLs so the
        // webpack-dev-server proxy forwards requests (including cookies) to dev.thetwinmaster.com
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return '';
        return DEV_BASE;
    }
    if (env === 'arche') return ARCHE_BASE;
    return '';
}

export function getCookie() {
    const env = getEnvType();
    if (env === 'local') return LOCAL_COOKIE;
    if (env === 'dev') return DEV_COOKIE;
    if (env === 'arche') return ARCHE_COOKIE;
    return '';
}

// Safely parse the twinup auth cookie. Returns {} when the cookie is
// missing or malformed (e.g. running locally without an authenticated session).
export function parseTwinupCookie(cookie) {
    if (!cookie || typeof cookie !== 'string') {
        // Fallback: use the token baked in at build time via .env.local
        const envToken = process.env.REACT_APP_DEV_ACCESS_TOKEN;
        if (envToken) return { access_token: envToken };
        return {};
    }
    // Case 1: raw JWT token (starts with "eyJ") – wrap into expected shape
    if (cookie.trim().startsWith('eyJ')) {
        return { access_token: cookie.trim() };
    }
    // Case 2: JSON-encoded object (normal production format)
    try {
        return JSON.parse(cookie.replace(/\\054/g, ',').replace(/\\/g, '').replace(/^\"/, '').replace(/\"$/, ''));
    } catch (error) {
        console.warn('Unable to parse twinup cookie:', error);
        const envToken = process.env.REACT_APP_DEV_ACCESS_TOKEN;
        if (envToken) return { access_token: envToken };
        return {};
    }
}

export function getCloudfront() {

    const env = getEnvType();
    console.log('Getting Cloudfront URL for environment:', env);
    if (env === 'local') return LOCAL_CLOUDFRONT;
    if (env === 'dev') return DEV_CLOUDFRONT;
    if (env === 'arche') return ARCHE_CLOUDFRONT;
    return '';
}

export function getCloudfrontS3() {
    const env = getEnvType();
    console.log('Getting Cloudfront S3 URL for environment:', env);
    if (env === 'local') return LOCAL_CLOUDFRONT_S3;
    if (env === 'dev') return DEV_CLOUDFRONT_S3;
    if (env === 'arche') return ARCHE_CLOUDFRONT_S3;
    return '';
}

// At the end of envUtils.js

// Only expose to window if running in the browser
if (typeof window !== "undefined") {
    window.getBaseUrl = getBaseUrl;
    window.getCookie = getCookie;
    window.getCloudfront = getCloudfront; // add more as needed
    window.getCloudfrontS3 = getCloudfrontS3;
}